import { defineStore } from 'pinia';

export const useAccessStore = defineStore('access', {
  state: () => ({
    isPartialAccessDenied: false,
    deniedMessage: '',
  }),
  actions: {
    setPartialAccessDenied(isDenied: boolean, message: string = '') {
      this.isPartialAccessDenied = isDenied;
      this.deniedMessage = message;
    },
  },
});
